
import { Component, Prop, Vue } from "vue-property-decorator";
import globalFunctional from "./global-functional.vue";

@Component({
  components: {
    globalFunctional
  }
})
export default class PreviewPhone extends Vue {
  @Prop({ default: [] }) data!: any;

  setGlobal(item: any) {
    this.$emit("setGlobal", item);
  }
}
